<template>
  <el-dialog v-dialogDrag v-loading="loading" title="请假申请（带草稿功能）" :visible.sync="dlgVisible"
    :close-on-click-modal="false" :close-on-press-escape="false" width="800px">
    <div>
      <ctrl ref="ctrl" />
      <div v-if="showBotton" class="check">
        <el-button size="small" type="primary" @click="queryApproveNodes"> 查询处理人设置 </el-button>
      </div>
      <flowNodesEditor v-show="flowNodesEditorVisible" ref="flowNodesEditor" :flow-key="params.flowKey"
        :flow-version-id="params.currentVersionId" />
    </div>
    <div slot="footer">
      <el-button type="primary" size="small" @click="handleSave">保存(不提交)</el-button>
      <el-button type="primary" :disabled="!showStartButtons" size="small" @click="handleSubmit">提交申请</el-button>
      <el-button type="default" size="small" @click="dlgVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import ctrl from "./index";
import flowNodesEditor from "@/CommonDP/pages/components/launchFlow/components/flowNodesEditor";
import leaveService from "@/CommonDP/service/leave-service";
import flowService from "@/CommonDP/service/flow-service";

export default {
  components: { ctrl, flowNodesEditor },
  data() {
    return {
      loading: false,
      dlgVisible: false,
      params: {},
      showBotton: false,
      flowNodesEditorVisible: false,
      showStartButtons: false,
      leaveId: ""
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
      prjInfo: state => state.projectMg.prjObj
    })
  },
  methods: {
    // 接口：约定给框架提供的方法
    openForStart(params) {
      console.debug(params);
      this.reset();
      this.params = params;
      this.leaveId = params.businessId || "";
      this.showBotton = true;
      this.dlgVisible = true;
      if (this.leaveId) {
        this.$nextTick(() => this.queryDraft());
      }
    },
    // 接口：约定给框架提供的方法
    openForRestart(params) {
      console.debug(params);
      this.reset();
      this.title = "请假申请（重新发起 ）";
      this.params = params;
      this.leaveId = params.businessId || "";
      this.isRestart = params.viewParam === "restart";
      this.showBotton = true;
      this.dlgVisible = true;
      this.$nextTick(() => this.queryDraft());
    },

    reset() {
      this.loading = false;
      this.dlgVisible = false;
      this.showBotton = false;
      this.flowNodesEditorVisible = false;
      this.showStartButtons = false;
      this.params = {};
      this.leaveId = "";
    },

    // 查询处理人设置
    async queryApproveNodes() {
      const success = await this.validateBeforeQueryNodes();
      if (success) {
        this.flowNodesEditorVisible = true;
        this.queryFlowNodes();
      }
    },

    async queryDraft() {
      const json = await flowService.queryDraft("leaveWithDraft", this.leaveId);
      console.debug("json-=====", json);
      this.$refs.ctrl.setFormData(json);
    },

    async validateBeforeQueryNodes() {
      return await this.$refs.ctrl.validate();
    },

    async queryFlowNodes() {
      const formData = this.$refs.ctrl.getFormData();
      const prjId = this.params.prjId || this.prjInfo.prjId;
      const success = await this.$refs.flowNodesEditor.queryFlowNodes(formData, prjId);
      if (success) {
        this.showStartButtons = true;
      }
    },

    async validateBeforeSubmit() {
      let success = await this.$refs.ctrl.validate();
      if (!success) {
        return false;
      }
      success = await this.$refs.flowNodesEditor.validate();
      if (!success) {
        return false;
      }
      return true;
    },

    async handleSave() {
      const json = this.makeSubmitParams();
      console.debug("json........", json);
      const res = await leaveService.leaveWtihDraftSaveDraft(json);
      this.leaveId = res.data || "";
      this.$success("保存成功");
      this.dlgVisible = false;
      this.$emit("refreshList");
    },

    async handleSubmit() {
      const success = await this.validateBeforeSubmit();
      if (!success) {
        return;
      }
      this.showStartButtons = false;
      this.loading = true;
      try {
        const json = this.makeSubmitParams();
        if (this.isRestart) {
          await leaveService.leaveWtihDraftRestart(json);
          this.$success("重新发起成功，请到我发起的流程中查看");
          this.$emit("refreshList");
        } else {
          await leaveService.leaveWtihDraftStart(json);
          this.$success("申请成功，请到我发起的流程中查看");
          this.$emit("refreshList");
        }
        this.dlgVisible = false;
      } catch (error) {
        this.showStartButtons = true;
      } finally {
        this.loading = false;
      }
    },

    makeSubmitParams() {
      const json = this.$refs.ctrl.getFormData();
      console.debug("json........", json);
      return {
        ...json,
        flowInstanceId: this.params.flowInstanceId || "",
        flowDefinitionId: this.params.flowDefinitionId,
        flowKey: this.params.flowKey,
        prjId: this.params.prjId || this.prjInfo.prjId,
        enterpriseId: this.routerParams.enterpriseId || this.enterpriseId,
        flowNodeDtoList: this.$refs.flowNodesEditor.getFlowNodeWithAddedUsers(),
        ccUserIdList: this.$refs.flowNodesEditor.expose_getCCUserIdList(),
        // 这时要带上业务数据 id
        leaveId: this.leaveId
      };
    }
  }
};
</script>

<style>
</style>
